import { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';
import { ROUTES } from 'core';
import { selectBasketExams } from 'store/basket/basketSlice';
import { useAppSelector } from 'store/hooks';

import { IcoBasket, Link, SecondaryNav } from '@britishcouncil/react-solas';

import IconLink from './IconLink';
import NavBtn from './NavBtn';

type AuthNavbarProps = {
  isLoggedIn?: boolean;
  username?: string;
  onLoginClick: () => void;
  onLogoutClick: () => void;
};

const AuthNavbar = ({ isLoggedIn = false, username, onLoginClick, onLogoutClick }: AuthNavbarProps) => {
  const exams = useAppSelector(selectBasketExams);
  const location = useLocation();

  const [stickedBasketLink, setStickedBasketLink] = useState(location.pathname === ROUTES.EXAMS);

  useEffect(() => setStickedBasketLink(location.pathname === ROUTES.EXAMS), [location]);

  return (
    <SecondaryNav>
      {!isLoggedIn ? (
        <>
          <NavBtn name={'Log in'} onClick={onLoginClick} />
          <Link to={ROUTES.SIGN_IN} name={'Sign up'} />
        </>
      ) : (
        <>
          {username && <Link to={ROUTES.MY_PROFILE} name={`Hello, ${username}`} />}
          <NavBtn name={'Log out'} onClick={onLogoutClick} />
        </>
      )}
      <IconLink
        to={ROUTES.BASKET}
        icon={<IcoBasket />}
        extraContent={`${exams.length}${exams.length > 0 ? ' - Proceed to basket' : ''}`}
        sticked={stickedBasketLink}
      />
    </SecondaryNav>
  );
};

export default AuthNavbar;
